import { Collection } from '../../lib/types';
import Card from '../Card';

export interface CollectionCardProps {
  collection: Collection;
  onRemoveCollection?: (collection: Collection) => void;
}

export const CollectionCard = ({
  collection,
  onRemoveCollection,
}: CollectionCardProps) => {
  return (
    <Card className="Collection">
      <Card.Link url={`/collection?id=${collection.ref}&page=1`}>
        <Card.Image imageSrc={collection.thumbnail} count={collection.total} />
        <Card.Footer>
          <h3>{collection.name}</h3>
        </Card.Footer>
      </Card.Link>
      {onRemoveCollection && collection.cant_delete === 0 && (
        <button
          className="collection-delete-button"
          onClick={() => onRemoveCollection(collection)}
        ></button>
      )}
    </Card>
  );
};
